import { IconSparkles, IconUpload } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

const ClipRecommendationEmptyState = () => {
  const navigate = useNavigate();

  const handleUploadClick = () => {
    navigate('/import');
  };

  return (
    <div className="flex w-full items-center justify-center rounded-xl border border-dashed border-slate-200 py-16">
      <div className="flex flex-col items-center">
        <IconSparkles size={24} stroke={1.5} className="text-slate-500" />
        <div className="mt-4 text-center text-sm font-semibold text-slate-500">
          Upload videos to get AI-curated content recommendations
        </div>
        <button
          className="mt-4 flex items-center gap-2 rounded-lg bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800"
          onClick={handleUploadClick}
          data-testid="clip-recommendation-upload-button"
          title="Upload Video"
          aria-label="Upload Video"
        >
          <IconUpload size={16} />
          Upload Video
        </button>
      </div>
    </div>
  );
};

export default ClipRecommendationEmptyState;
